import React from "react";
import UniversalWorklistLayout from "./components/UniversalWorklistLayout";

interface NotificationsPageProps {}

const NotificationsPage = (props: NotificationsPageProps) => {
  return (
    <UniversalWorklistLayout>
      <div className="text-center py-5">
        <i className="ti ti-bell fs-48 text-muted mb-3 d-block"></i>
        <h4 className="text-muted mb-2">No Notifications</h4>
        <p className="text-muted">There are currently no notifications to display.</p>
      </div>
    </UniversalWorklistLayout>
  );
};

export default NotificationsPage;
